import { emptyV2Api as api } from "../../../emptyV2Api";
import { PlanUploadJobItem } from "./planUploadJobItem";
import { UsimSkuItem } from "./usimSkuItem";

export const addTagTypes = ["UsimSku"] as const;
const SLUG = "/usim/product-plans"
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getUsimSkus: build.query<UsimSkuItem[], void>({
        query: () => ({
          url: SLUG + "/manage?version=new",
          method: "GET",
        }),
        providesTags: ["UsimSku"],
      }),
      getUsimSku: build.query<UsimSkuItem, string>({
        query: (usimSku) => ({
          url: SLUG + "/manage?version=new&?plan=" + usimSku,
          method: "GET",
        }),
        providesTags: ["UsimSku"],
      }),
      getUsimSkuByType: build.query<UsimSkuItem[], string>({
        query: (typeName) => ({
          url: SLUG + "/manage?version=new&typeName=" + typeName,
          method: "GET",
        }),
        providesTags: ["UsimSku"],
      }),
      getUsimSkuUploadJobs: build.query<PlanUploadJobItem[], void>({
        query: () => SLUG + "/upload",
        providesTags: ["UsimSku"],      
      }),
      postUsimSku: build.mutation<UsimSkuItem, UsimSkuItem>({
        query: (usimSku) => ({
          url: SLUG + "/manage?version=new",
          method: "POST",
          body: usimSku,
        }),
        invalidatesTags: ["UsimSku"],
      }),
      putUsimSku: build.mutation<UsimSkuItem, UsimSkuItem>({
        query: (usimSku) => ({
          url: SLUG + "/manage?version=new",
          method: "PUT",
          body: usimSku,
        }),
        invalidatesTags: ["UsimSku"],
      }),
      deleteUsimSku: build.mutation<UsimSkuItem, UsimSkuItem>({

        query: (usimSku) => ({
          url: SLUG + "/manage?version=new&id=" + `${usimSku.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["UsimSku"],
      }),
    }),
  });

export const {
  useGetUsimSkusQuery,
  useGetUsimSkuQuery,
  usePostUsimSkuMutation,
  usePutUsimSkuMutation,
  useDeleteUsimSkuMutation,
  useGetUsimSkuUploadJobsQuery,
  useGetUsimSkuByTypeQuery,
} = injectedRtkApi;
